import { render, staticRenderFns } from "./SearchResubmit.vue?vue&type=template&id=6c71ffe0&scoped=true"
import script from "./SearchResubmit.vue?vue&type=script&lang=js"
export * from "./SearchResubmit.vue?vue&type=script&lang=js"
import style0 from "./SearchResubmit.vue?vue&type=style&index=0&id=6c71ffe0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_cache-loader@4.1.0_webpack@4.47.0__css-load_4e3969014a7d8e6dd81c256359e01f18/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c71ffe0",
  null
  
)

export default component.exports